module.exports = __webpack_public_path__ + "img/bg-7.8796f1d8.jpg";